import { useState, useRef } from 'react';
import cx from "classnames";
import Popover from "../Popover";


const timeMap = {
    "now-1d": "last 24h",
    "now-7d": "last 7 days",
    "now-30d": "last 30 days",
    "1970-01-01": "anytime"
};

const sortMap = {
    "": "relevance",
    "distance": "location",
    "time": "time"
};


export default function ItemsTools({ onChange, params, total }) {
    const [areTimeOptionsVisible, setAreTimeOptionsVisible] = useState(false);
    const [areSortOptionsVisible, setAreSortOptionsVisible] = useState(false);
    const timeRef = useRef(null);
    const sortRef = useRef(null);

    const { time, order } = params;

    const onOrderChange = (order) => {
        onChange({ ...params, order });
        setAreSortOptionsVisible(false);
    };

    const onTimeChange = (time) => {
        onChange({ ...params, time });
        setAreTimeOptionsVisible(false);
    };

    return (
        <div className="flex px-2.5 py-2.5 text-xs justify-end items-center bg-[#f0f0f0] z-[1]">

            {total !== undefined && <span className="mr-auto text-xs font-normal text-[#313039]">{total} results</span>}

            <span className="cursor-pointer flex justify-end items-center mr-[15px]"
                onClick={() => setAreTimeOptionsVisible(true)}
                ref={timeRef}>
                <span className="whitespace-nowrap text-xs text-[#a7a6ad] font-light hide-small">Created</span>
                <span className="ml-1 text-sm font-light">{timeMap[time]}</span>
                <i className="fa fa-chevron-down pl-1 text-cyan text-[8px]" />

                {areTimeOptionsVisible && (
                    <Popover
                        parent={timeRef.current}
                        onClose={() => setAreTimeOptionsVisible(false)}
                        setPosition={p => ({ top: p.bottom, left: p.left, width: p.width })}>
                        <div className="bg-white text-[#484848] text-sm shadow-[0_3px_3px_0_rgba(0,0,0,0.2)] py-1">
                            {Object.entries(timeMap).map(([k, v]) => (
                                <div key={k}
                                    onClick={() => onTimeChange(k)}
                                    className={cx("cursor-pointer px-2.5 py-1 hover:bg-gray-50", { 'text-cyan': time == k })}>
                                    {v}
                                </div>
                            ))}
                        </div>
                    </Popover>
                )}
            </span>

            <span className="cursor-pointer flex justify-end items-center"
                onClick={() => setAreSortOptionsVisible(true)}
                ref={sortRef}>
                <span className="whitespace-nowrap text-xs text-[#a7a6ad] font-light hide-small">Sort by</span>
                <span className="ml-1 text-sm font-light">{sortMap[order]}</span>
                <i className="fa fa-chevron-down pl-1 text-cyan text-[8px]" />

                {areSortOptionsVisible && (
                    <Popover
                        parent={sortRef.current}
                        onClose={() => setAreSortOptionsVisible(false)}
                        setPosition={p => ({ top: p.bottom, left: p.left, width: p.width })}>
                        <div className="bg-white text-[#484848] text-sm shadow-[0_3px_3px_0_rgba(0,0,0,0.2)] py-1">
                            {Object.entries(sortMap).map(([k, v]) => (
                                <div key={k}
                                    onClick={() => onOrderChange(k)}
                                    className={cx("cursor-pointer px-2.5 py-1 hover:bg-gray-50", { 'text-cyan': order == k })}>
                                    {v}
                                </div>
                            ))}
                        </div>
                    </Popover>
                )}
            </span>

        </div>
    );
}
